module.exports = __webpack_public_path__ + "static/media/gps1.49de4a1a.svg";